import _ from 'lodash'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setActiveTrain } from '../redux/actions/setActiveTrain'

export function useModelToggleEventListenner() {
  const dispatch = useDispatch()

  useEffect(() => {
    function onReceiveModalToggle(event) {
      const trainId = _.get(event, 'detail')
      if (trainId) {
        dispatch(setActiveTrain(trainId))
      }
    }
    window.addEventListener(
      'ylg_toggle_train_modal',
      onReceiveModalToggle
    )
    return () => window.removeEventListener('', onReceiveModalToggle)
  }, [dispatch])
}
